import React, { memo } from "react";
import LayoutGridIcon from "./images/icons/layout-grid.svg?react";
import LayoutListIcon from "./images/icons/layout-list.svg?react";
import { clsx } from "clsx";
import "./LayoutTabs.scss";

type TLayoutTabsSize = "l" | "m" | "s";

interface ILayoutTabs {
  isGrid: boolean;
  onChangeLayout: () => void;
  size?: TLayoutTabsSize;
}

export const LayoutTabs: React.FC<ILayoutTabs> = memo(({
  isGrid,
  onChangeLayout,
  size = "l"
}) => {
  return (
    <div className={clsx("LayoutTabs", `LayoutTabs_${size}`)}>
      <button
        onClick={onChangeLayout}
        className={clsx("LayoutTabs-Tab", isGrid && "LayoutTabs-Tab_isActive")}
        aria-label="Switch to grid layout"
      >
        <LayoutGridIcon />
      </button>
      <button
        onClick={onChangeLayout}
        className={clsx("LayoutTabs-Tab", !isGrid && "LayoutTabs-Tab_isActive")}
        aria-label="Switch to list layout"
      >
        <LayoutListIcon />
      </button>
    </div>
  );
});
